import Vue from 'vue';
import { gsap } from 'gsap';
import { SplitText } from '../gsap-bonus/SplitText';

gsap.registerPlugin(SplitText);

Vue.component('text-switch-component', {

    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        const animationText = [...this.$el.querySelectorAll('.animation-text')];

        if (animationText.length < 1) {
            return;
        }

        gsap.set(animationText[0], {
            yPercent: 0,
            autoAlpha: 1,
        });

        EventBus.$on('build-page:next-tick', () => {
            this.switchText();
        });
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        switchText() {
            const animationText = [...this.$el.querySelectorAll('.animation-text')];
            const splitText = animationText.map((text) => {
                const split = new SplitText(text, { type: 'chars, words' });
                return split;
            });

            if (animationText.length < 1) {
                return;
            }

            gsap.set(animationText[0], {
                yPercent: 0,
                autoAlpha: 1,
            });

            const stagger = 0.032;
            const offset = '-=0.35';
            const delay = 1.2;

            const tl = gsap.timeline({
                paused: false,
                delay,
                repeatDelay: 0,
                onComplete: () => {
                    for (let index = 0; index < animationText.length; index++) {
                        const element = animationText[index];
                        gsap.set(element, {
                            yPercent: 100,
                        });
                    }

                    for (let index = 0; index < splitText.length; index++) {
                        const text = splitText[index];
                        gsap.set(text.chars, {
                            'font-variation-settings': '"wght" 200, "wdth" 100',
                        });
                    }

                    const tl2 = gsap.timeline(({
                        paused: false,
                        repeat: -1,
                        repeatDelay: 0,
                    }));

                    tl2.to(animationText[0], {
                        yPercent: 0,
                        ease: 'power3.out',
                    });

                    tl2.to(splitText[0].chars, {
                        duration: 0.6,
                        ease: 'power3.out',
                        stagger,
                        'font-variation-settings': '"wght" 800, "wdth" 100',
                    }, offset);

                    tl2.to(animationText[0], {
                        yPercent: -100,
                        ease: 'power3.in',
                        onComplete: () => {
                            animationText[0].style.fontVariationSettings = '"wght" 200, "wdth" 100';
                        },
                    }, `>${delay}`);

                    tl2.to(animationText[1], {
                        yPercent: 0,
                        ease: 'power3.out',
                    });

                    tl2.to(splitText[1].chars, {
                        duration: 0.6,
                        stagger,
                        ease: 'power3.out',
                        'font-variation-settings': '"wght" 800, "wdth" 100',
                    }, offset);

                    tl2.to(animationText[1], {
                        yPercent: -100,
                        ease: 'power3.in',
                    }, `>${delay}`);

                    tl2.to(animationText[2], {
                        yPercent: 0,
                        ease: 'power3.out',
                    });

                    tl2.to(splitText[2].chars, {
                        duration: 0.6,
                        stagger,
                        ease: 'power3.out',
                        'font-variation-settings': '"wght" 800, "wdth" 100',
                    }, offset);

                    tl2.to(animationText[2], {
                        yPercent: -100,
                        ease: 'power3.in',
                    }, `>${delay}`);
                },
            });

            tl.to(animationText[0], {
                yPercent: 0,
                ease: 'power3.out',
            });

            tl.to(splitText[0].chars, {
                duration: 0.6,
                ease: 'power3.out',
                stagger,
                'font-variation-settings': '"wght" 800, "wdth" 100',
            }, offset);

            tl.to(animationText[0], {
                yPercent: -100,
                ease: 'power3.in',
                onComplete: () => {
                    animationText[0].style.fontVariationSettings = '"wght" 200, "wdth" 100';
                },
            }, `>${delay}`);

            tl.to(animationText[1], {
                y: 0,
                ease: 'power3.out',
            });

            tl.to(splitText[1].chars, {
                duration: 0.6,
                stagger,
                ease: 'power3.out',
                'font-variation-settings': '"wght" 800, "wdth" 100',
            }, offset);

            tl.to(animationText[1], {
                yPercent: -100,
                ease: 'power3.in',
            }, `>${delay}`);

            tl.to(animationText[2], {
                y: 0,
                ease: 'power3.out',
            });

            tl.to(splitText[2].chars, {
                duration: 0.6,
                stagger,
                ease: 'power3.out',
                'font-variation-settings': '"wght" 800, "wdth" 100',
            }, offset);

            tl.to(animationText[2], {
                yPercent: -100,
                ease: 'power3.in',
            }, `>${delay}`);
        },
    },

    beforeDestroy() {
        EventBus.$off('build-page:next-tick', this.switchText);
    },
});
